import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/index';
import { Input, Button, message } from 'antd';
import { apiResetPassword, apiGetPage } from '../../request/api';
import { useCustomData } from '../../pages/context/loginCustomDataProvider';

interface ResetPasswordProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string | null;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?: string;
    verifyIdentityFor?: string;
    sendIdentifying?: string;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ handleViewChange, data }) => {
    const navigate = useNavigate();
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [error1, setError1] = useState<string | null | undefined>(null);
    const [error2, setError2] = useState<string | null | undefined>(null);
    const [isHovered, setIsHovered] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { getValue, customData } = useCustomData();
    const [loginInfo, setLoginInfo] = useState<loginInfo>({
        loginName: "", email: "", phone: "", password: "", verification: "", account: "", emailError: "", sendVerification: "",
        phoneError: "", accountError: "", passwordError: "", verificationError: "", enterAccount: "", enterEmail: "",
        enterPassword: "", enterPasswordAgain: "", enterVerification: "", enterPhone: "", forget: "", verifyIdentityFor: "",
        getBack: "", next: "", check1: "", verifyIdentity: "", resetPassword: "", orInfo: "", backLogin: "", seccond: "", changeInfo: "",
        sendIdentifying: ''
    });
    useEffect(() => {
        if (customData.length === 0) return; // 数据还没来
        const newLoginInfo: loginInfo = {
            loginName: getValue('loginName'),
            email: getValue('email'),
            phone: getValue('phone'),
            password: getValue('password'),
            verification: getValue('verification'),
            account: getValue('account'),
            emailError: getValue('emailError'),
            phoneError: getValue('phoneError'),
            accountError: getValue('accountError'),
            passwordError: getValue('passwordError'),
            verificationError: getValue('verificationError'),
            enterAccount: getValue('enterAccount'),
            enterEmail: getValue('enterEmail'),
            enterPassword: getValue('enterPassword'),
            enterPasswordAgain: getValue('enterPasswordAgain'),
            enterVerification: getValue('enterVerification'),
            enterPhone: getValue('enterPhone'),
            forget: getValue('forget'),
            getBack: getValue('getBack'),
            next: getValue('next'),
            check1: getValue('check1'),
            verifyIdentity: getValue('verifyIdentity'),
            resetPassword: getValue('resetPassword'),
            orInfo: getValue('orInfo'),
            backLogin: getValue('backLogin'),
            seccond: getValue('seccond'),
            changeInfo: getValue('changeInfo'),
        };
        setLoginInfo(newLoginInfo);
    }, [customData]);


    const backToLoginPage = () => {
        handleViewChange('mainLogin', data?.acount);
    };

    const validatePassword = (pass: string, setError: (msg: string | null | undefined) => void) => {
        if (pass.length < 6) {
            setError(loginInfo.passwordError);
        } else {
            setError(null);
        }
    };

    const changePassword1 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const pass = e.target.value;
        setPassword1(pass);
        setError1(null); // 输入时清除错误
    };

    const changePassword2 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const pass = e.target.value;
        setPassword2(pass);
        setError2(null); // 输入时清除错误
    };

    const loginIn = () => {
        let hasErrors = false;
        // 验证第一个密码
        if (!password1) {
            setError1('密码不能为空');
            hasErrors = true;
        } else if (password1.length < 6) {
            setError1(loginInfo.passwordError);
            hasErrors = true;
        }

        // 验证第二个密码
        if (!password2) {
            setError2('确认密码不能为空');
            hasErrors = true;
        } else if (password2.length < 6) {
            setError2(loginInfo.passwordError);
            hasErrors = true;
        }

        // 验证密码一致性
        if (password1 && password2 && password1 !== password2) {
            setError2('两次输入的密码不一致');
            hasErrors = true;
        }

        if (hasErrors) return;

        // 保持原有的API调用逻辑
        apiResetPassword({
            account: data,
            password: password1,
        }).then(res => {
            if (res.data.ret === '40203') {
                messageApi.open({
                    type: 'error',
                    content: res.data.msg,
                });
            } else {
                messageApi.open({
                    type: 'success',
                    content: '密码重置成功',
                });
                setTimeout(() => {
                    handleViewChange('mainLogin')
                }, 3000)
            }
            console.log(res)
        });
    };

    const goLogin = () => {
        handleViewChange('mainLogin')
    }

    return (
        <div>
            {contextHolder}
            <div className='login-header'>{loginInfo.resetPassword}</div>
            <div className='login-body'>
                <span>{data}</span>
                <span onClick={backToLoginPage} className='cursur' style={{ color: themeColor, cursor: 'pointer' }}>{loginInfo.changeInfo}</span>
            </div>
            <div className='login-body_header'>{loginInfo.password}</div>
            <Input.Password
                status={error1 ? 'error' : ''}
                placeholder={loginInfo.enterPassword}
                value={password1}
                onChange={changePassword1}
            />
            {error1 && (
                <div style={{ height: '0px', color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                    {error1}
                </div>
            )}
            <Input.Password
                status={error2 ? 'error' : ''}
                placeholder={loginInfo.enterPasswordAgain}
                value={password2}
                style={{ marginTop: "25px" }}
                onChange={changePassword2}
            />
            {error2 && (
                <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                    {error2}
                </div>
            )}
            <Button type="primary" onClick={loginIn}>{loginInfo.check1}</Button>
            <div className='or-div'>
                <div className='line'></div>
                <div className='line-text'>{loginInfo.orInfo}</div>
                <div className='line'></div>
            </div>
            <Button className='return-login' style={{ margin: 0 }} onClick={goLogin}>{loginInfo.backLogin}</Button>
        </div>
    );
};

export default ResetPassword;